import React from 'react';
import cn from 'classnames';
import { Button } from 'swag-client-common/components/ui/button';
import AnimationWrapper from 'swag-client-common/components/animation-wrapper';
import dashboardImage from 'assets/img/landings/masks-for-all/dashboard.png';
import circleContainerImage from 'assets/img/landings/masks-for-all/circle-container.png';
import peopleImage from 'assets/img/landings/masks-for-all/people.png';
import calendarImage from 'assets/img/landings/masks-for-all/calendar.png';
import { redirectWithSavingScroll } from 'swag-client-common/utils/tricks';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import ss from './distribution.scss';
const CardThirdText = ({
  isInventory
}) => /*#__PURE__*/React.createElement(React.Fragment, null, isInventory ? /*#__PURE__*/React.createElement("div", {
  className: ss.cardThirdText
}, /*#__PURE__*/React.createElement("h3", {
  className: ss.titleWrapper
}, "Connect to the people that matter")) : /*#__PURE__*/React.createElement("div", {
  className: ss.cardThirdText
}, /*#__PURE__*/React.createElement("h3", null, "Swag", /*#__PURE__*/React.createElement("br", null), "Distribution"), /*#__PURE__*/React.createElement("p", null, "Send swag to one location or to thousands of locations at once!"), /*#__PURE__*/React.createElement(Button, {
  className: cn(ss.shopMasksBtn, ss.buttonDesktop),
  type: "secondary",
  size: "large",
  onClick: redirectWithSavingScroll(APP_ROUTES.DISTRIBUTE)
}, "Find Out More")));
const Distribution = ({
  bgClassName,
  isInventory
}) => /*#__PURE__*/React.createElement("div", {
  className: cn(ss.containerThird, bgClassName)
}, /*#__PURE__*/React.createElement("div", {
  className: cn(ss.cardThird)
}, /*#__PURE__*/React.createElement(AnimationWrapper, {
  className: ss.cardThirdTextWrapper,
  offset: 200
}, /*#__PURE__*/React.createElement(CardThirdText, {
  isInventory: Boolean(isInventory)
})), /*#__PURE__*/React.createElement(AnimationWrapper, {
  offset: 200
}, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
  className: ss.cardThirdIcons
}, /*#__PURE__*/React.createElement("div", {
  className: ss.cardThirdIcon
}, /*#__PURE__*/React.createElement("img", {
  src: dashboardImage,
  alt: "Customer service excellence icon with a user silhouette and three stars"
}), /*#__PURE__*/React.createElement("p", null, "Engage with your", /*#__PURE__*/React.createElement("br", null), "Remote Employees")), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
  className: ss.cardThirdIcon
}, /*#__PURE__*/React.createElement("img", {
  src: circleContainerImage,
  alt: "Award ribbon icon enclosed in a dashed circular border"
}), /*#__PURE__*/React.createElement("p", null, "Reward your best", /*#__PURE__*/React.createElement("br", null), "customers")), /*#__PURE__*/React.createElement("div", {
  className: ss.cardThirdIcon
}, /*#__PURE__*/React.createElement("img", {
  src: peopleImage,
  alt: "Icon of three interconnected people, symbolizing a team or network, enclosed within a dashed circular border"
}), /*#__PURE__*/React.createElement("p", null, "Convert prospects", /*#__PURE__*/React.createElement("br", null), "and leads")), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
  className: ss.cardThirdIcon
}, /*#__PURE__*/React.createElement("img", {
  src: calendarImage,
  alt: "Calendar icon with a star marking a special date, enclosed within a dashed circular border"
}), /*#__PURE__*/React.createElement("p", null, "Humanize online", /*#__PURE__*/React.createElement("br", null), "events and meetings")), /*#__PURE__*/React.createElement("hr", null), !isInventory && /*#__PURE__*/React.createElement("div", {
  className: ss.buttonMobileLink
}, /*#__PURE__*/React.createElement(Button, {
  className: cn(ss.shopMasksBtn, ss.buttonMobile),
  type: "secondary",
  size: "large",
  onClick: redirectWithSavingScroll(APP_ROUTES.DISTRIBUTE)
}, "Find Out More")))))));
export default Distribution;